module.exports = __webpack_public_path__ + "static/longitudinal-export-7ebe53ac0892a968940107074296faf4.png";